import React from "react";
import { Trans } from "app/utils";

const EmptyStories: React.FC = () => (
  <p>
    <Trans>
      Looks like there are no stories with your current selection.
      Adjust the filters and try again!
    </Trans>
  </p>
);

export default EmptyStories;
